import "./Footer.css";

const Footer = function (props) {
    return (
        <div className="container">
                <div className="row no-gutters">
                    <div className="footerDetails col-12 col-md-6">
                        <div className="contactUsDetail">
                            <div className="contactUsIcon float-right">
                                <img className="img-fluid" src="/SiteCollectionImages/Footer/phone.png" alt="phoneIcon"/>
                            </div>
                            <div>
                                <span className="contactUsTitle">טלפון - בימי קבלת קהל</span>
                                <a className="d-md-none d-block" href={"tel:"+props.data.ModFooterPhone}>{props.data.ModFooterPhone}</a>
                                <span className="contactUsText d-none d-md-block">{props.data.ModFooterPhone}</span>
                            </div>
                        </div>
                        <div className="contactUsDetail">
                                <div className="contactUsIcon">
                                    <img className="img-fluid" src="/SiteCollectionImages/Footer/mail-i.png" alt="mailIcon"/>   
                                </div>
                                <div className="">
                                    <span className="contactUsTitle">דואר אלקטרוני</span>
                                    <a href={"mailto:"+props.data.MODFooterEMail}>{props.data.MODFooterEMail}</a>
                                </div>
                        </div>
                        <div className="contactUsDetail">
                                <div className="contactUsIcon">
                                        <img className="img-fluid" src="/SiteCollectionImages/Footer/location-i.png" alt="locationIcon"/>   
                                </div>
                                <div>
                                    <span className="contactUsTitle">כתובת לדואר</span>
                                    <div className="contactUsText" dangerouslySetInnerHTML={{__html: props.data.MODFooterAddress}}></div>
                                </div>
                        </div>
                        <div className="contactUsDetail">
                                <div className="contactUsIcon">
                                        <img className="img-fluid" src="/SiteCollectionImages/Footer/clock-big-i.png" alt="clockIcon"/>   
                                </div>
                                <div className="footerReception">
                                    <span className="contactUsTitle">קבלת קהל - בתיאום מראש</span>
                                    <div className="contactUsText" dangerouslySetInnerHTML={{__html: props.data.MODFooterReception}}></div>
                                </div>
                    </div>
                    </div>
                    <div className="d-none d-md-block col-md-6">
                    <img className="leftFooterImg img-fluid" src="/SiteCollectionImages/Footer/computer.png" />
                    </div>
                </div>
            </div>
    );
}
export default Footer;
